import {createApp} from 'vue'
import options from './ProfileSettingsHero.options'

const el = '.kb-component--profile-settings-hero'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((ProfileSettingsHeroDOM)=>{
            options.template = ProfileSettingsHeroDOM.innerHTML
            const props = {
                userData: JSON.parse(ProfileSettingsHeroDOM.dataset.userData),
                editProfileInformationUrl: ProfileSettingsHeroDOM.dataset.editProfileInformationUrl,
                editPasswordUrl: ProfileSettingsHeroDOM.dataset.editPasswordUrl,
                editEmailUrl: ProfileSettingsHeroDOM.dataset.editEmailUrl
            }
            const component = createApp(options, props).use(Store)
            component.mount(ProfileSettingsHeroDOM)
        })
    }
}